<section class="container flex flex-col gap-4">
    <h2 class="text-left text-4xl font-extrabold hammersmith-one-regular uppercase">Emails</h2>
    <ul>
        @for (email of emails; track $index) {
            <li>{{ email }}</li>
        }
    </ul>
</section>
